document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('[data-countdown]').forEach(function(el){var mins=parseInt(el.dataset.countdown||'15',10),left=mins*60;function tick(){var m=Math.floor(left/60),s=left%60;el.textContent=m+':'+String(s).padStart(2,'0');left=left>0?left-1:mins*60}tick();setInterval(tick,1000)})});

// Popups de actividad y reseñas de ejemplo
(function(){
  function initSocialProof(){
    var source=document.querySelector('[data-social-proof]');
    var popup=document.querySelector('[data-proof-popup]');
    if(!source||!popup) return;
    if(source.dataset.mobile==='false' && window.matchMedia('(max-width: 850px)').matches) return;
    var items=[].slice.call(source.querySelectorAll('[data-proof-item]'));
    if(!items.length) return;
    var delay=parseInt(source.dataset.delay||'5000',10);
    var interval=parseInt(source.dataset.interval||'12000',10);
    var duration=parseInt(source.dataset.duration||'5000',10);
    var index=0, hideTimer=null, loopTimer=null;
    var title=popup.querySelector('[data-proof-title]');
    var message=popup.querySelector('[data-proof-message]');
    var stars=popup.querySelector('[data-proof-stars]');
    var avatar=popup.querySelector('[data-proof-avatar]');
    var close=popup.querySelector('[data-proof-close]');

    function hide(){
      popup.classList.remove('is-visible');
      window.setTimeout(function(){popup.hidden=true;},260);
    }
    function show(){
      var item=items[index%items.length]; index++;
      var kind=item.dataset.kind||'purchase';
      var who=item.dataset.name||'Cliente';
      var where=item.dataset.location ? ' · '+item.dataset.location : '';
      title.textContent=who+where;
      message.textContent=item.dataset.message||'';
      if(kind==='review'){
        var n=Math.max(1,Math.min(5,parseInt(item.dataset.stars||'5',10)));
        stars.textContent='★'.repeat(n)+'☆'.repeat(5-n);
        stars.hidden=false;
        avatar.textContent='★';
      }else{
        stars.hidden=true;
        avatar.textContent='✓';
      }
      popup.hidden=false;
      requestAnimationFrame(function(){requestAnimationFrame(function(){popup.classList.add('is-visible');});});
      clearTimeout(hideTimer); hideTimer=setTimeout(hide,duration);
    }
    if(close) close.addEventListener('click',hide);
    setTimeout(function(){show(); loopTimer=setInterval(show,interval);},delay);
    window.addEventListener('beforeunload',function(){clearInterval(loopTimer);clearTimeout(hideTimer);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSocialProof); else initSocialProof();
})();
